import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCamino = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "96.000000pt",
	height: "98.000000pt",
	viewBox: "0 0 96.000000 98.000000",
	preserveAspectRatio: "xMidYMid meet",
	id: "svg3773",
	"sodipodi:docname": "Camino.svg",
	"inkscape:version": "1.2.2 (b0a8486, 2022-12-01)",
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { id: "defs3777" }),
		/* @__PURE__ */ _jsx("sodipodi:namedview", {
			id: "namedview3775",
			pagecolor: "#ffffff",
			bordercolor: "#000000",
			borderopacity: .25,
			"inkscape:showpageshadow": 2,
			"inkscape:pageopacity": 0,
			"inkscape:pagecheckerboard": 0,
			"inkscape:deskcolor": "#d1d1d1",
			"inkscape:document-units": "pt",
			showgrid: "false",
			"inkscape:zoom": 1.8061224,
			"inkscape:cx": 64.502825,
			"inkscape:cy": 65.333333,
			"inkscape:window-width": 1309,
			"inkscape:window-height": 456,
			"inkscape:window-x": 2636,
			"inkscape:window-y": 576,
			"inkscape:window-maximized": 0,
			"inkscape:current-layer": "svg3773"
		}),
		/* @__PURE__ */ _jsx("metadata", {
			id: "metadata3767",
			children: "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n"
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(0.000000,98.000000) scale(0.050000,-0.050000)",
			fill: "#000000",
			stroke: "none",
			id: "g3771",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M857 1630 c-707 -145 -765 -1154 -78 -1358 265 -79 526 -23 709 150 l122 116 -49 36 c-27 20 -55 41 -64 46 -8 6 -14 60 -14 120 0 185 -2 245 -14 382 l-12 133 72 44 71 44 -39 56 c-131 183 -441 285 -704 231z m322 -153 c-18 -62 -17 -63 29 -45 18 7 27 19 22 28 -6 9 6 14 25 11 27 -4 35 -25 37 -98 2 -95 -34 -102 -63 -11 -6 21 -24 38 -40 38 -17 0 -24 -13 -16 -35 9 -30 7 -30 -11 -5 -12 17 -22 22 -22 12 0 -10 -29 12 -63 48 l-64 67 45 16 c49 18 82 8 82 -25 0 -11 -10 -14 -22 -7 -15 10 -15 1 1 -29 31 -58 36 -53 30 25 -3 43 4 66 21 66 18 0 21 -15 9 -56z m-221 28 c-2 -8 -1 -19 1 -25 16 -42 14 -80 -6 -81 -13 -1 -5 -10 17 -19 39 -17 38 -17 -4 -19 -24 0 -53 -17 -64 -36 -12 -19 -21 -26 -21 -14 -1 12 10 32 23 45 19 19 18 24 -5 24 -42 0 -86 -73 -53 -88 13 -7 2 -6 -26 1 -67 16 -96 41 -106 93 -5 24 -6 15 -3 -21 5 -44 -1 -61 -15 -52 -14 8 -16 4 -8 -10 8 -13 22 -19 30 -14 8 5 15 -3 15 -19 0 -16 -9 -23 -20 -16 -12 8 -15 -1 -7 -20 8 -21 3 -32 -12 -29 -13 3 -27 -20 -30 -50 -4 -31 -15 -50 -25 -44 -28 17 -23 -19 6 -48 14 -14 16 -23 5 -19 -11 3 -21 -2 -23 -12 -2 -10 -16 -25 -30 -34 -21 -13 -19 -17 8 -18 22 0 35 -15 35 -40 0 -22 -8 -40 -18 -40 -9 0 -22 -17 -27 -39 -8 -27 -2 -35 18 -27 16 6 27 3 25 -7 -7 -40 3 -68 22 -57 11 7 14 -1 8 -19 -7 -17 -22 -25 -35 -17 -13 7 -6 -7 15 -31 21 -23 50 -43 65 -43 15 0 26 -7 25 -15 -7 -40 6 -132 15 -110 6 14 28 25 49 25 41 0 46 -39 19 -150 l-15 -60 -34 70 c-26 52 -32 57 -24 20 8 -42 6 -45 -14 -20 -13 17 -44 30 -68 28 -39 -2 -42 3 -22 40 20 37 19 39 -8 17 -56 -46 -82 21 -89 231 -10 274 -20 403 -31 414 -9 10 -17 -26 -15 -75 0 -14 4 -135 8 -270 8 -264 0 -289 -53 -164 -21 49 -24 75 -10 66 13 -8 6 7 -16 33 -22 26 -29 40 -15 32 32 -18 34 40 2 60 -15 9 -18 5 -7 -12 10 -16 8 -21 -4 -14 -11 7 -21 42 -22 77 -1 48 4 57 17 36 13 -21 18 -11 19 37 0 37 -8 61 -18 55 -10 -6 -15 5 -12 24 4 19 8 47 8 61 1 15 12 20 25 12 16 -10 20 2 13 38 -6 29 -3 48 7 42 9 -6 18 -1 20 11 1 11 3 32 5 46 1 14 18 25 37 25 19 0 49 21 66 45 20 28 23 45 9 45 -13 0 18 32 69 70 50 39 98 70 106 70 8 0 4 -7 -9 -16 -14 -9 -17 -26 -7 -42 13 -21 20 -17 30 15 21 67 47 51 47 -28 0 -40 6 -78 14 -85 8 -8 11 13 7 46 -5 45 1 58 23 53 17 -3 23 0 15 8 -19 20 22 69 57 69 16 0 27 -7 26 -15z m249 -304 c112 -84 133 -93 133 -60 0 21 4 39 8 39 5 0 23 5 40 12 25 10 32 -2 32 -52 0 -49 -7 -62 -30 -53 -39 15 -38 1 7 -64 20 -29 42 -63 50 -76 7 -13 -11 -52 -40 -87 -45 -54 -48 -62 -16 -57 40 7 61 -42 41 -95 -14 -37 -92 6 -92 51 0 19 -17 12 -55 -23 -148 -139 -345 -218 -345 -138 0 29 38 56 140 103 111 52 214 135 115 93 -14 -6 -98 -43 -188 -82 -171 -76 -233 -77 -223 -5 5 36 36 49 213 90 127 29 199 55 188 66 -11 11 -38 11 -67 1 -108 -39 -399 -71 -423 -47 -64 64 9 93 252 99 305 7 309 44 5 44 -249 0 -315 25 -246 94 29 30 50 29 257 -10 320 -60 316 -23 -4 43 -158 33 -191 53 -171 104 17 44 105 28 280 -52 141 -63 161 -69 143 -41 -15 24 -166 102 -198 102 -37 0 -71 41 -59 72 21 57 119 29 253 -71z m113 -622 c0 -12 -11 -15 -23 -7 -16 10 -20 4 -11 -19 7 -18 5 -33 -4 -33 -9 0 -13 -20 -8 -45 7 -37 -1 -46 -43 -48 -52 -3 -68 20 -31 43 12 7 16 20 11 28 -11 19 62 102 90 102 10 0 19 -10 19 -21z m-170 -133 c-1 -31 5 -62 16 -68 10 -7 -5 -13 -34 -13 -59 0 -61 2 -80 85 -8 36 -6 50 4 34 14 -21 23 -20 43 5 35 42 56 24 51 -43z m-190 28 c0 -9 9 -11 20 -4 28 18 25 -17 -5 -49 -14 -15 -15 -21 -3 -15 12 7 33 -12 47 -41 23 -52 23 -53 -12 -22 -20 17 -48 28 -62 23 -14 -5 -25 6 -25 24 0 18 -11 30 -25 25 -14 -5 -25 -18 -25 -30 0 -12 -5 -27 -12 -34 -10 -10 -10 16 0 119 2 24 102 27 102 4z",
				id: "path3769"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "path3831",
			"sodipodi:type": "arc",
			"sodipodi:cx": 58.13559,
			"sodipodi:cy": 25.538136,
			"sodipodi:rx": 9.1355934,
			"sodipodi:ry": 4.775424,
			"sodipodi:start": 0,
			"sodipodi:end": .98722335,
			"sodipodi:arc-type": "slice",
			d: "m 67.271183,25.538136 a 9.1355934,4.775424 0 0 1 -4.101798,3.985087 L 58.13559,25.538136 Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "path3833",
			"sodipodi:type": "arc",
			"sodipodi:cx": 45.055084,
			"sodipodi:cy": 75.991531,
			"sodipodi:rx": 9.3432207,
			"sodipodi:ry": 4.5677967,
			"sodipodi:start": 0,
			"sodipodi:end": .98722335,
			"sodipodi:arc-type": "slice",
			d: "m 54.398305,75.991531 a 9.3432207,4.5677967 0 0 1 -4.195021,3.811823 l -5.1482,-3.811823 z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3835",
			width: 14.949152,
			height: 11.211864,
			x: 49.415257,
			y: 20.762712
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3837",
			width: 14.533897,
			height: 8.7203398,
			x: 34.881355,
			y: 22.008476
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3839",
			width: 4.5677967,
			height: 3.737288,
			x: 61.872883,
			y: 30.728813
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3841",
			width: 19.516949,
			height: 9.550848,
			x: 41.525425,
			y: 72.669495
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3843",
			width: 9.550848,
			height: 12.042374,
			x: 27.822035,
			y: 26.161016
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3845",
			width: 12.457628,
			height: 10.79661,
			x: 55.228813,
			y: 67.68644
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3849",
			width: 6.6440678,
			height: 5.3983049,
			x: 31.559322,
			y: 24.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3851",
			width: 4.9830508,
			height: 5.3983049,
			x: 61.872883,
			y: 26.991526
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3853",
			width: 13.288136,
			height: 5.3983049,
			x: 33.635593,
			y: 29.898304
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3855",
			width: 6.6440678,
			height: 16.194916,
			x: 31.14407,
			y: 62.703392
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3857",
			width: 8.3050842,
			height: 11.627119,
			x: 37.372883,
			y: 71.008469
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3859",
			width: 5.3983049,
			height: 20.347458,
			x: 17.855932,
			y: 42.35593
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3861",
			width: 10.79661,
			height: 7.0593224,
			x: 21.59322,
			y: 31.14407
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3863",
			width: 9.9661016,
			height: 39.44915,
			x: 22.423729,
			y: 34.05085
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3865",
			width: 14.949152,
			height: 5.8135595,
			x: 19.101696,
			y: 37.372883
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3867",
			width: 4.5677967,
			height: 2.9067798,
			x: 19.932203,
			y: 62.703392
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3869",
			width: 4.9830508,
			height: 4.1525421,
			x: 29.483051,
			y: 58.966103
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#000000",
				strokeWidth: .75
			},
			id: "rect3871",
			width: 6.2288141,
			height: 3.737288,
			x: 36.127117,
			y: 69.762711
		})
	]
});
export default SvgCamino;
